import { gql } from "@apollo/client";

const CREATE_TAG = gql`
  mutation createTag(
    $name: String!
    $color: String!
    $companyId: ID!
    $companyIdString: String!
    $key: String!
  ) {
    createTag(
      data: {
        name: $name
        color: $color
        company: { connect: { id: $companyId } }
        companyId: $companyIdString
        key: $key
        clientCount: 0
      }
    ) {
      id
      name
      createdAt
      color
      isDefault
    }
  }
`;

// Crear tag con spaceId (para compañía específica)
const CREATE_TAG_WITH_SPACE = gql`
  mutation createTag(
    $name: String!
    $color: String!
    $companyId: ID!
    $companyIdString: String!
    $key: String!
    $spaceId: String!
  ) {
    createTag(
      data: {
        name: $name
        color: $color
        company: { connect: { id: $companyId } }
        companyId: $companyIdString
        key: $key
        clientCount: 0
        spaceId: $spaceId
      }
    ) {
      id
      name
      createdAt
      color
      isDefault
      spaceId
    }
  }
`;

const EDIT_TAG = gql`
  mutation updateTag($id: ID!, $name: String!, $color: String!, $key: String!) {
    updateTag(
      where: { id: $id }
      data: { name: $name, color: $color, key: $key   }
    ) {
      id
      name
      color
      isDefault
      createdAt
    }
  }
`;

const GET_TAGS = gql`
  query getTags($companyId: String!) {
    tags(where: { companyId: $companyId }) {
      id
      name
      createdAt
      color
      key
      isDefault
      spaceId
    }
  }
`;

// Obtener tags filtrados por spaceId (para compañía específica)
const GET_TAGS_BY_SPACE = gql`
  query getTags($companyId: String!, $spaceId: String!) {
    tags(where: { companyId: $companyId, spaceId: $spaceId }) {
      id
      name
      createdAt
      color
      key
      isDefault
      spaceId
    }
  }
`;

const GET_NOT_DEFAULT_TAGS = gql`
  query getNotDefaultTags($companyId: String!) {
    tags(where: { companyId: $companyId, isDefault: false }) {
      id
      name
      createdAt
      color
      clientCount
      spaceId
    }
  }
`;

// Obtener tags no default filtrados por spaceId (para compañía específica)
const GET_NOT_DEFAULT_TAGS_BY_SPACE = gql`
  query getNotDefaultTags($companyId: String!, $spaceId: String!) {
    tags(where: { companyId: $companyId, isDefault: false, spaceId: $spaceId }) {
      id
      name
      createdAt
      color
      clientCount
      spaceId
    }
  }
`;

const DELETE_TAG = gql`
  mutation deleteTag($id: ID!) {
    deleteTag(where: { id: $id }) {
      id
    }
  }
`;

const UPSERT_TAG = gql`
  mutation upsertTag(
    $name: String!
    $color: String!
    $companyId: ID!
    $companyIdString: String!
    $key: String!
  ) {
    upsertTag(
      where: { key: $key }
      update: {
        key: $key
      }
      create: {
        name: $name
        color: $color
        company: { connect: { id: $companyId } }
        companyId: $companyIdString
        key: $key
        clientCount: 0
      }
    ) {
      id
    }
  }
`;

// Upsert tag con spaceId (para compañía específica)
const UPSERT_TAG_WITH_SPACE = gql`
  mutation upsertTag(
    $name: String!
    $color: String!
    $companyId: ID!
    $companyIdString: String!
    $key: String!
    $spaceId: String!
  ) {
    upsertTag(
      where: { key: $key }
      update: {
        key: $key
      }
      create: {
        name: $name
        color: $color
        company: { connect: { id: $companyId } }
        companyId: $companyIdString
        key: $key
        clientCount: 0
        spaceId: $spaceId
      }
    ) {
      id
    }
  }
`;

const ApolloTags = {
  CREATE_TAG,
  CREATE_TAG_WITH_SPACE,
  GET_TAGS,
  GET_TAGS_BY_SPACE,
  GET_NOT_DEFAULT_TAGS,
  GET_NOT_DEFAULT_TAGS_BY_SPACE,
  DELETE_TAG,
  EDIT_TAG,
  UPSERT_TAG,
  UPSERT_TAG_WITH_SPACE,
};

export default ApolloTags;
